import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Controller, useForm } from "react-hook-form";
import { Col, Row } from "react-bootstrap";
import { useNavigate } from "react-router-dom";
import "flatpickr/dist/flatpickr.css";
import { FormattedMessage, useIntl } from "react-intl";
import Loader from "components/shared/Loader";
import { addSection, getAllPageSections } from "store/actions";
import AddButton from "components/shared/AddButton";
import { toastErrorMessage } from "helpers/toaster/toastErrorMessage";
import ReactSelect from "react-select";
import ImagesUpload from "components/shared/ImagesUpload";
import { Input } from "components/shared/FormComponents";
import { numInputValidations } from "helpers/functions";
import SlidersArray from "./SliderArray";
import { Editor } from "components/shared/Editor";
const AddProjects = () => {
  const { formatMessage, locale } = useIntl();
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { loading, error, sections, section } = useSelector(
    (state) => state.section
  );

  const [slider, setSlider] = useState([]);
  const [features, setFeatures] = useState([]);
  const [description, setDescription] = useState({});

  const {
    register,
    handleSubmit,
    control,
    formState: { errors },
  } = useForm();
  // effects
  useEffect(() => {
    dispatch(getAllPageSections("categories-1"));
  }, [dispatch]);
  // error
  useEffect(() => {
    if (error) {
      toastErrorMessage(formatMessage({ id: "sendingErrorMessage" }), locale);
    }
  }, [error, formatMessage, locale]);

  const onSubmit = (data) => {
    data.images = slider.map((image) => {
      return image.path;
    });
    data.features = features;
    data.description = description;
    dispatch(
      addSection({
        page: "projects",
        data: { section: { title: data.projectTitle.en, ...data } },
        navigate: () => navigate("/projects"),
      })
    );
  };

  if (loading) return <Loader />;

  return (
    <>
      <div className="acc-form">
        <div className="card">
          <div className="card-head">
            <h4>
              <FormattedMessage id={"addProduct"} />
            </h4>
          </div>
          <div className="card-body">
            <form onSubmit={handleSubmit(onSubmit)}>
              <Row>
                <Col lg={12} xs={12}>
                  <div className="form-group ">
                    <h5>
                      <FormattedMessage id={"images"} />
                    </h5>
                    <ImagesUpload
                      imagesURLs={slider}
                      setImageURLs={setSlider}
                    />
                  </div>
                </Col>
                <Row />
                <Col xs={12}>
                  <div className="form-group ">
                    {/* categories dropdown */}
                    <Col xs={12}>
                      <div className="form-group ">
                        <h5>
                          <FormattedMessage id="category" />
                        </h5>

                        <Controller
                          control={control}
                          name="category"
                          rules={{ required: true }}
                          render={({
                            field: { onChange, value, name, ref },
                          }) => (
                            <ReactSelect
                              inputRef={ref}
                              name={name}
                              placeholder={section?.category?.title?.[locale]}
                              options={sections.map((c) => ({
                                value: c?.slug,
                                label: c?.sectionTitle?.[locale],
                                response: c,
                              }))}
                              onChange={(selectedOption) => {
                                onChange(selectedOption.response);
                              }}
                              isRtl={true}
                              isSearchable={true}
                              className="basic-single"
                              classNamePrefix="select"
                            />
                          )}
                        />
                      </div>
                    </Col>
                    {/* availability dropdown*/}
                    <Col xs={12}>
                      <div className="form-group">
                        <div className="form-check">
                          <input
                            type="checkbox"
                            id="isAvailable"
                            className="form-check-input"
                            {...register("isAvailable")}
                          />
                          <label
                            htmlFor="isAvailable"
                            className="form-check-label"
                          >
                            <h5>
                              <FormattedMessage id="availability" />
                            </h5>
                          </label>
                        </div>
                      </div>
                    </Col>
                  </div>
                </Col>
                <Col lg={6} xs={12}>
                  <Input
                    langId="title"
                    name="projectTitle.ar"
                    register={register}
                    errors={errors}
                  />
                </Col>
                <Col lg={6} xs={12}>
                  <Input
                    langId="title"
                    name="projectTitle.en"
                    register={register}
                    errors={errors}
                  />
                </Col>
                <Col lg={6} xs={12}>
                  <div>
                    <Controller
                      control={control}
                      name="description.ar"
                      render={({ field: { value } }) => (
                        <Editor
                          initialValue=""
                          onChange={(e, editor) => {
                            const data = editor.getContent();
                            setDescription((prevState) => {
                              const nextState = { ...prevState, ar: data };
                              return nextState;
                            });
                          }}
                          tinymceScriptSrc="https://cdn.tiny.cloud/1/qagffr3pkuv17a8on1afax661irst1hbr4e6tbv888sz91jc/tinymce/5-stable/tinymce.min.js"
                        />
                      )}
                    />
                    <p className="error-hint">
                      {errors.description?.ar?.type === "required" && (
                        <FormattedMessage id="required" />
                      )}
                    </p>
                  </div>
                </Col>
                <Col lg={6} xs={12}>
                  <div>
                    <Controller
                      control={control}
                      name="description.en"
                      render={({ field: { value } }) => (
                        <Editor
                          initialValue=""
                          onChange={(e, editor) => {
                            const data = editor.getContent();
                            setDescription((prevState) => {
                              const nextState = { ...prevState, en: data };
                              return nextState;
                            });
                          }}
                          tinymceScriptSrc="https://cdn.tiny.cloud/1/qagffr3pkuv17a8on1afax661irst1hbr4e6tbv888sz91jc/tinymce/5-stable/tinymce.min.js"
                        />
                      )}
                    />
                    <p className="error-hint">
                      {errors.description?.ar?.type === "required" && (
                        <FormattedMessage id="required" />
                      )}
                    </p>
                  </div>
                </Col>
                <Col lg={6} xs={12}>
                  <Input
                    langId="location"
                    name="location.ar"
                    register={register}
                    rules={{ required: true }}
                    errors={errors}
                  />
                </Col>
                <Col lg={6} xs={12}>
                  <Input
                    langId="location"
                    name="location.en"
                    register={register}
                    rules={{ required: true }}
                    errors={errors}
                  />
                </Col>
                <Col lg={6} xs={12}>
                  <Input
                    langId="price"
                    name="price"
                    register={register}
                    rules={{ required: true }}
                    errors={errors}
                    {...numInputValidations}
                  />
                </Col>
              </Row>
              <SlidersArray sliders={features} setSliders={setFeatures} />
              <AddButton />
            </form>
          </div>
        </div>
      </div>
    </>
  );
};

export default AddProjects;
